import { connect } from 'react-redux';
import {
    actions
} from '../../../../../redux/modules/Reporte/deuda';
import OrdenesPorC from '../ordenesPorCoP/ordenespor';

const mstp = state => {
    return {...state.Reportes, es_cliente:true, permisos: state.login.me.permisos, id_user: state.login.me.id}
};

const mdtp = {
    ...actions
};

export default connect(mstp, mdtp)(OrdenesPorC)